import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Lock } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { api } from "../lib/api";

export default function ResetPassword() {
  const { t } = useLanguage();
  const a = t.acc;
  const a2 = t.acc2;
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [form, setForm] = useState({ password: "", repeat: "" });
  const [error, setError] = useState(() => (params.get("token") ? "" : a2.resetErr));
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (form.password !== form.repeat) {
      setError(a2.pwdMismatch);
      return;
    }
    if (form.password.length < 8) {
      setError(a.errPwd);
      return;
    }
    try {
      await api.accountReset({ token, password: form.password });
      setDone(true);
    } catch {
      setError(a2.resetErr);
    }
  };

  const inputCls =
    "w-full border border-white/15 bg-transparent px-4 py-3 text-sm text-white outline-none transition-colors focus:border-gold placeholder:text-white/35";

  return (
    <div data-testid="reset-password-page" className="noise-bg flex min-h-screen items-center justify-center bg-navy px-6 pt-32 pb-24">
      <div className="w-full max-w-md">
        <div className="border border-white/10 bg-white/5 p-10 backdrop-blur-sm">
          <Lock size={28} strokeWidth={1.25} className="text-gold" />
          <h1 className="mt-6 font-display text-3xl font-light text-white">{a2.resetTitle}</h1>
          {done ? (
            <div className="mt-8">
              <p data-testid="reset-success" className="text-sm text-gold">{a2.resetOk}</p>
              <Link to="/account" data-testid="reset-goto-login" className="mt-6 inline-block bg-gold px-8 py-3.5 text-[11px] font-bold uppercase tracking-[0.18em] text-navy transition-colors hover:bg-gold-dark">
                {a.loginTab}
              </Link>
            </div>
          ) : (
            <form onSubmit={submit} data-testid="reset-form" className="mt-8 space-y-5">
              <input
                data-testid="reset-password-input"
                type="password"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                placeholder={a.password}
                required
                className={inputCls}
              />
              <input
                data-testid="reset-repeat-input"
                type="password"
                value={form.repeat}
                onChange={(e) => setForm({ ...form, repeat: e.target.value })}
                placeholder={a2.repeatPwd}
                required
                className={inputCls}
              />
              {error && <p data-testid="reset-error" className="text-xs text-red-300">{error}</p>}
              <button type="submit" data-testid="reset-submit" className="w-full bg-gold py-3.5 text-[11px] font-bold uppercase tracking-[0.18em] text-navy transition-colors hover:bg-gold-dark">
                {a2.resetBtn}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
